export class ValueReferenceParameter {
  public systemKey: string;
  public linkKey: string;
  public institutionNo: string;
  public regionalInstitutionNo: string;
  public hisInfoGetterParameter: string;
}
